import type { MatchRead } from '@volee/api-client'

/** Whether the whistle is still to come: scheduled, and the kickoff not yet passed. A postponed match
 *  is not before its kickoff — it has none to wait for — and a scheduled one past its hour is not
 *  either, whatever the result says. The match page puts the Convocati first only until then. */
export function isBeforeKickoff(
  match: Pick<MatchRead, 'status' | 'kicks_off_at'>,
  now: Date = new Date(),
): boolean {
  return match.status === 'scheduled' && new Date(match.kicks_off_at).getTime() > now.getTime()
}

/** Whether the whistle has gone, as the server counts it (`clock.has_started`): the kick-off is not after
 *  now, whatever the status says. The server refuses an answer and a change of who is called on this, so the
 *  call-up section asks it rather than `isBeforeKickoff`, which also reads a postponed match as not started. */
export function hasStarted(kicksOffAt: string, now: Date = new Date()): boolean {
  return new Date(kicksOffAt).getTime() <= now.getTime()
}
